export enum FileType {
  notes = "Notes",
  url = "URL",
}
